// @flow
import * as React from 'react';
import {useState} from 'react';

import Group from 'sail/Group';
import {Heading, Body} from 'sail/Text';
import Dialog, {DialogHeader, DialogContent, DialogFooter} from 'sail/Dialog';
import Button from 'sail/Button';
import {useDiagramGenerator} from 'docs/data';
import {generateId} from '../util/generateId';
import {SetNodeId} from './SetNodeId';
import {SetNodeText} from './SetNodeText';
import {SetNodeState} from './SetNodeState';

export const AddStateNode = () => {
  const {addNode} = useDiagramGenerator();
  const [state, setState] = useState('');
  const [text, setText] = useState('');
  // Autogenerate an ID for this node
  const [id, setId] = useState('');

  return (
    <Dialog width="large">
      <DialogHeader title="Add node" />
      <DialogContent padding={20}>
        <Group spacing={16}>
          <Group spacing={4}>
            <Heading>Node content</Heading>
            <Body>
              State diagram nodes have a text label, with an optional state
              attribute. Adding a state to a node changes the background color
              and adds an icon next to the label.
            </Body>
          </Group>
          <Group spacing={20} direction="horizontal">
            <SetNodeText
              text={text}
              setText={(val) => {
                if (!id) {
                  setId(generateId(val));
                }
                setText(val);
              }}
            />
            <SetNodeState value={state} onChange={setState} />
          </Group>
          <SetNodeId id={id} setId={setId} />
        </Group>
      </DialogContent>
      <DialogFooter
        end={
          <Button
            label="Add"
            onClick={() => {
              addNode({id, state}, text);
            }}
          />
        }
      />
    </Dialog>
  );
};
